import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('lmtTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allValues: '<',
      valueSelections: '<',
      paramRequired: '<',
      readOnly: '<',
      valueMappings: '<'
    },
    template: require("../templates/lmtTargeting.html"),
    controllerAs: '$lmtTargetingCtrl',
    controller: function() {
      this.allCustomOptions2 = componentHelper.allCustomOptions2();
    }
});
